// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__DPrCZ","content":"style_content__uXODf","button":"style_button__biHlZ","title":"style_title__hsFLH","info":"style_info__VT9zy"};